import { render, staticRenderFns } from "./Dataset.vue?vue&type=template&id=3b28bfc8&"
import script from "./Dataset.vue?vue&type=script&lang=js&"
export * from "./Dataset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports